import { useState } from "react";
import ExpandedModal from "../common/mediaGallery/ExpandedModal";
import { cleanHTML, cleanHTML2 } from "../utils/commonHelper";

const ExpandedComponent = ({ item }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleConfirm = () => {
    //console.log("Confirmed!");
    setIsModalOpen(false);
  };

  // Prepare media for modal
  const media = [];
  if (item.image) {
    media.push({
      image: item.image,
    });
  }
  // You can add more images/videos dynamically if needed
  // e.g., media.push(...item.additionalImages.map(img => ({ image: img })))

  return (
    <>
      <div className="bg-[#f0f2f0] rounded-[15px] overflow-hidden">
        <div
          title="Click to view media"
          className="topSection bg-[#f0f2f0] hover:bg-[#ccc]/20 flex flex-col items-center justify-center "
        >
          {item.image && (
            <img
              src={process.env.REACT_APP_BACKEND_URL + "public/" + item.image}
              className=" w-full h-full  cursor-pointer object-contain"
              alt={item.title}
              onClick={handleOpenModal}
              onError={(e) => {
                e.currentTarget.src = require("../../assets/images/link.png"); // path to default image
                e.currentTarget.classList.add("object-contain"); // optional styling
              }}
            />
          )}
          <div className="bg-gray w-full h-[40px] px-4 flex items-center justify-between">
            <p
              className="mb-0 text-18pt hover:text-orange cursor-pointer"
              title="Click to view media"
              onClick={handleOpenModal}
            >
              {media.length + item.pictures?.length + " Photo(s)"}
              {item.videosCount > 0 && ", " + item.videosCount + " Video(s)"}
            </p>
            <p className="mb-0 text-18pt">{item.date && item.date.formattedDate}</p>
          </div>
        </div>

        {item.description && (
          <div className="bottomSection px-8 py-4">
            <h5 className="text-34pt mb-3 text-green leading-tight">{item.title}</h5>
            <h5 className="text-24pt mb-2 font-mono text-secondary">{item.shortDescription}</h5>
            <div
              className="terms-container"
              dangerouslySetInnerHTML={{ __html: cleanHTML2(item.description) }}
            />
          </div>
        )}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <ExpandedModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onConfirm={handleConfirm}
          data={{
            title: item.title,
            pictures: [...media, ...item.pictures],
            videos: item.videos, // populate if you have videos
          }}
        />
      )}
    </>
  );
};

export default ExpandedComponent;
